/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnInit } from '@angular/core';
import {
  ControlContainer,
  FormBuilder,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { IAccount } from '../../interfaces/account/account.interface';
import { AddedDevices } from '../../interfaces/financials/added-devices-response.interface';
import { IProviderGroup } from '../../interfaces/provider/provider-group.interfaces';
import { AlertService } from '../../services/alert.service';
import { FinancialsService } from '../../services/financials/financials.service';
import { ProviderGroupGQLService } from '../../services/provider/provider-group.graphql.service';
import { ProviderGroupService } from '../../services/provider/provider-group.service';

@Component({
  selector: 'financials',
  templateUrl: './financials.component.html',
  styleUrls: ['./financials.component.scss'],
})
export class FinancialsComponent implements OnInit {
  @Input() isReadOnly = false;
  @Input() groupId: string;
  @Input() accountNumber: string;
  @Input() account: IAccount;
  providerGroupFinancialsForm: UntypedFormGroup;
  providerGroupForm: UntypedFormGroup;
  deviceForm: FormGroup;
  providerGroupDetails: IProviderGroup;
  modalOpen = false;
  isEditMode: boolean;
  addedDevicesGrid: AddedDevices[] = [];
  private currentDeviceDetailId?: string;

  constructor(
    private providerGroupGQLService: ProviderGroupGQLService,
    private providerGroupService: ProviderGroupService,
    private formBuilder: FormBuilder,
    private fb: UntypedFormBuilder,
    private financialsService: FinancialsService,
    private controlContainer: ControlContainer,
    private alertService: AlertService,
  ) {}

  ngOnInit() {
    this.isEditMode = !!this.groupId;
    this.providerGroupGQLService.getProviderGroup(this.groupId).subscribe({
      next: (data) => {
        console.log('data:', data);
        this.providerGroupDetails = data;
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });

    this.providerGroupFinancialsForm = this.controlContainer
      .control as UntypedFormGroup;
    this.loadData();
    this.initForm();
  }

  validateAllowingACHInputKey() {
    const allowACHKeyInput: HTMLInputElement | null =
      document.querySelector('#ach-key-input');

    if (allowACHKeyInput) {
      const providerGroupFinancialsFormAch =
        this.providerGroupFinancialsForm.get('allowACH');
      if (providerGroupFinancialsFormAch) {
        allowACHKeyInput.disabled =
          providerGroupFinancialsFormAch.value === 'Y' ? false : true;
      } else {
        allowACHKeyInput.disabled = true;
      }
    }
  }

  loadData() {
    this.financialsService.getAddedDevicesByGroupId(this.groupId).subscribe({
      next: (data) => {
        this.addedDevicesGrid = data.map((item, index) => {
          const newItem: AddedDevices = {
            ...item,
            index,
            saved: true,
            error: false,
          };
          return newItem;
        });
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });
  }

  initForm() {
    this.deviceForm = this.formBuilder.group({
      deviceName: ['', Validators.required],
      deviceIdentifier: ['', Validators.required],
      isDefault: [false],
    });
    if (this.isReadOnly) {
      this.deviceForm.disable();
    }
  }

  manageConfig(): any {
    this.providerGroupService
      .manageGPSettings(this.groupId)
      .subscribe((data) => {
        window.open(data.tiny_link as string, '_blank');
      });
  }

  openModal(): void {
    this.modalOpen = true;
  }
  close(): void {
    this.modalOpen = false;
    this.deviceForm.reset();
  }

  addDevices() {
    const devicesFormValue = this.deviceForm.getRawValue();

    const deviceDetail: AddedDevices = {
      ...devicesFormValue,
      groupId: this.groupId,
      accountNumber: this.accountNumber,
      saved: false,
      error: false,
    };

    const index = this.addedDevicesGrid.findIndex((x) => {
      return x.deviceIdentifier == this.currentDeviceDetailId;
    });

    if (deviceDetail.isDefault == undefined) {
      deviceDetail.isDefault = false;
    }

    if (index >= 0) {
      this.addedDevicesGrid[index] = {
        ...this.addedDevicesGrid[index],
        ...deviceDetail,
      };
    } else {
      this.addedDevicesGrid.push(deviceDetail);
    }

    this.deviceForm.reset();
    this.currentDeviceDetailId = undefined;
    this.close();
  }

  getDevicesData(): AddedDevices[] {
    return this.addedDevicesGrid.map((pd) => {
      return pd.paymentsDeviceId
        ? {
            paymentsDeviceId: pd.paymentsDeviceId,
            deviceName: pd.deviceName,
            deviceIdentifier: pd.deviceIdentifier,
            isDefault: pd.isDefault,
            saved: pd.saved,
            error: pd.error,
          }
        : {
            deviceName: pd.deviceName,
            deviceIdentifier: pd.deviceIdentifier,
            isDefault: pd.isDefault,
            saved: pd.saved,
            error: pd.error,
          };
    });
  }
}
